import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

export const Route = createFileRoute("/app/admin/customers/")({
  validateSearch: listSearch,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
